import type * as React from 'react';

import type * as api from '@gitbook/api-client';
import { Picker, type PickerItemData } from '@gitbook/react-uikit';
import { Icon } from '@gitbook/spine-icons';
import { Description, FieldGroup, Group, Label, Link } from '@gitbook/spine-react';

import type { SitesCustomizationPanelProps } from '../../types';

/**
 * Settings to configure the style for the search button
 */
export function AnnouncementStyleSettings(props: SitesCustomizationPanelProps): React.ReactElement {
    const { settings, setSettings } = props;

    return (
        <FieldGroup orientation="vertical">
            <Group>
                <Label>Style</Label>
                <Description>
                    Choose the type of your announcement. To change colors, modify the site's{' '}
                    <Link href="https://gitbook.com/docs/publishing-documentation/customization#semantic-colors">
                        semantic colors
                    </Link>
                    .
                </Description>
            </Group>
            <Picker
                value={settings.announcement?.style ?? 'info'}
                items={OPTIONS}
                onValueChange={(value) => {
                    setSettings((prev) => ({
                        ...prev,
                        announcement: {
                            enabled: true,
                            message: '',
                            ...prev.announcement,
                            style: value ?? 'info',
                        },
                    }));
                }}
            />
        </FieldGroup>
    );
}

const OPTIONS: PickerItemData<api.CustomizationAnnouncement['style']>[] = [
    {
        value: 'info',
        label: 'Info',
        icon: <Icon.InfoCircle className="text-primary" />,
    },
    {
        value: 'warning',
        label: 'Warning',
        icon: <Icon.Warning className="text-warning" />,
    },
    {
        value: 'danger',
        label: 'Danger',
        icon: <Icon.Alert className="!text-danger" />,
    },
    {
        value: 'success',
        label: 'Success',
        icon: <Icon.CheckCircle className="text-success" />,
    },
];
